import { Box } from "@mui/material";
import HeaderPhoto from "../../assets/images/savanna_remnant.jpg";
import PageHeader from "../../components/PageHeader";
import Overview from "./Overview";
import Culture from "./Culture";
import History from "./History";
import Landscape from "./Landscape";
import NaturalAreas from "./NaturalAreas";
import Restoration from "./Restoration";
import Beauty from "./Beauty";
import Videos from "./Videos";

function Essays() {
  return (
    <Box>
      <PageHeader image={HeaderPhoto} title="Essays and Links" />
      {/* <Overview /> */}
      <Beauty />
      <Culture />
      <History />
      <Landscape />
      <NaturalAreas />
      <Restoration />
      <Videos />
    </Box>
  );
}

export default Essays;
